module.exports = __webpack_public_path__ + "static/media/mode-15.f5bd90c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-15.svg
// module id = 970
// module chunks = 2